import { useEffect } from 'react';
import { getCurrentRef } from '../refs';
/**
 * Adds an event listener to the provided target ref. Removes the event listener on unmount.
 */
export function useEventListener(targetRef, eventType, listener, options) {
    useEffect(() => {
        const element = getCurrentRef(targetRef);
        element.addEventListener(eventType, listener, options);
        return () => {
            element.removeEventListener(eventType, listener);
        };
    }, [targetRef, eventType, listener, options]);
}
//# sourceMappingURL=use-event-listener.js.map